import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

export function ModalWrap({ children }: PropsWithChildren) {
  return <StyledWrap>{children}</StyledWrap>
}

const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overscroll-behavior: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 21000;
  width: 100%;
  height: 100%;
`
